import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, Validators, FormGroup, FormArray } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConexionesService } from 'src/app/services/conexiones.service';

@Component({
  selector: 'app-editar-conexion',
  templateUrl: './editar-conexion.component.html',
  styleUrls: ['./editar-conexion.component.scss'],
})
export class EditarConexionComponent implements OnInit {
  form = this.fb.group({
    id_conexiones: [''],
    cantidad: [
      '',
      [Validators.required, Validators.max(30), Validators.pattern('^[0-9]*$')],
    ],
    id_usuarios_creador: [sessionStorage.getItem('id_usuario')],
  });

  constructor(
    public dialogRef: MatDialogRef<EditarConexionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public conexionesService: ConexionesService,
    public _snackBar: MatSnackBar
  ) {
    this.setInfo();
  }

  ngOnInit(): void {}

  setInfo() {
    this.form.controls.id_conexiones.setValue(this.data.id_conexiones);
    this.form.controls.cantidad.setValue(this.data.cantidad);
  }
}
